import {
  Box,
  Heading,
  Dialog,
  Button,
  Spinner,
  ButtonGroup,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import CustomerGroupForm from "../CustomerGroupForm";
import { NotFound } from "../../../../404";
import {
  useCustomerGroup,
  useCustomerGroupDelete,
} from "../../../../hooks/useCustomerGroup";
import { useEffect, useRef, useState } from "react";

export default function CustomerGroupEditPage() {
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const cancelRef = useRef(null);
  const customerGroup = useCustomerGroup(id);
  const customerGroupDelete = useCustomerGroupDelete();

  useEffect(() => {
    if (customerGroupDelete.isSuccess) {
      setOpen(false);
    }
  }, [customerGroupDelete.isSuccess]);

  if (customerGroup.isLoading) {
    return <Spinner />;
  }

  if (!id || !customerGroup.data) {
    return <NotFound />;
  }

  return (
    <Box>
      <Heading as="h1" mb={4}>
        Endre kundegruppe
      </Heading>
      <CustomerGroupForm group={customerGroup.data} />
      <Button colorPalette="red" mt={8} onClick={() => setOpen(true)}>
        Slett kundegruppe
      </Button>
      <Dialog.Root open={open} onOpenChange={(e) => setOpen(e.open)} role="alertdialog">
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header fontSize="lg" fontWeight="bold">
              Slette kundegruppe
            </Dialog.Header>

            <Dialog.Footer>
              {customerGroupDelete.isPending && <Spinner />}
              {!customerGroupDelete.isPending && (
                <ButtonGroup>
                  <Button ref={cancelRef} onClick={() => setOpen(false)}>
                    Avbryt
                  </Button>
                  <Button
                    colorPalette="red"
                    onClick={() => {
                      customerGroupDelete.mutate({ groupUuid: id });
                    }}
                    ml={3}
                  >
                    Slett
                  </Button>
                </ButtonGroup>
              )}
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Dialog.Root>
    </Box>
  );
}
